<template>
  <div
    class="page-wrapper"
    style="z-index: 2200; margin-left: 0; background: rgba(0,0,0,0.5)"
  >
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div class="container-fluid mt-0">
      <div class="card px-4 pb-4 col-lg-8 mx-auto">
        <div
          class="page-breadcrumb p-2 mb-4"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
        >
          <div>
            <h4 class="page-title">{{ $t("setup-device") }}</h4>
          </div>
        </div>
        <div
          v-if="mssg"
          align="center"
          class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>
        <div
          v-else-if="Errormssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ Errormssg }}
          </p>
        </div>
        <form @submit.prevent="onSave">
          <div class="form-group">
            <label>{{ $t("device-name") }}</label>
            <input
              type="text"
              name="name"
              v-model="devicename"
              class="form-control"
              required
            />
          </div>

          <div class="form-group">
            <label>{{ $t("address-device-location") }}</label>
            <input
              type="text"
              name="location"
              v-model="location"
              class="form-control"
              required
            />
          </div>

          <div class="form-group">
            <label>
              {{ $t("short-description") }}
              <span class="text-muted">{{ $t("description-words") }}</span>
            </label>
            <textarea
              rows="4"
              style="resize:none"
              class="form-control"
              name="device_desc"
              v-model="deviceDescription"
              required
            ></textarea>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("minimum-temperature") }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    name="min_temp"
                    class="form-control"
                    v-model="mintemp"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">°C</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("maximum-temperature") }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    name="max_temp"
                    class="form-control"
                    v-model="maxtemp"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">°C</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p v-if="tempmssg" class="my-0 small text-error p-1">
            {{ tempmssg }}
          </p>

          <div v-if="singledevice.data.type === 'box'" class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t("set-point") }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    name="min_temp"
                    class="form-control"
                    v-model="preset"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">°C</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="singledevice.data.type === 'box'" class="card">
            <div class="p-2 card-body">
              <div class="row">
                <div class="col-8" style="display: flex; align-items: center;">
                  {{ $t("lock-unlock") }}
                </div>
                <div
                  class="mb-2 col-4 pl-0 pt-2 d-flex"
                  style="justify-content: flex-end"
                >
                  <span
                    v-if="boxstatus"
                    @click="changeboxstatus"
                    style="display: flex; align-items: center; cursor: pointer; width: 5rem; justify-content: flex-end; background: green; border-radius: 1rem"
                  >
                    <span
                      class="border border-grey shadow-inner shadow small"
                      style="width: 3rem; height: 2rem; background: white; border-radius: 1rem; display: flex; justify-content: center; align-items: center;"
                      >{{ $t("locked") }}
                    </span>
                  </span>
                  <span
                    v-else
                    @click="changeboxstatus"
                    class="border border-grey"
                    style="display: flex; align-items: center; cursor: pointer; width: 5rem; justify-content: flex-start; background: gray; border-radius: 1rem"
                  >
                    <span
                      class="border border-grey shadow-innershadow small"
                      style="width: 3rem; height: 2rem; background: white; border-radius: 1rem; display: flex; justify-content: center; align-items: center;"
                      >{{ $t("unlocked") }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              singledevice.data.type === 'mote' ||
                singledevice.data.type === 'gps-vt'
            "
            class="row"
          >
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("min-humid") }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    name="minHumi"
                    class="form-control"
                    v-model="minHumi"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("max-humid") }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    name="maxHumi"
                    class="form-control"
                    v-model="maxHumi"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p
            v-if="
              humimssg &&
                (singledevice.data.type === 'mote' ||
                  singledevice.data.type === 'gps-vt')
            "
            class="my-0 mb-2 small text-error p-1"
          >
            {{ humimssg }}
          </p>

          <div
            v-if="
              singledevice.data.type === 'mote' ||
                singledevice.data.type === 'gps-vt'
            "
            class="form-group"
          >
            <label class="mb-0">{{ $t("interval") }}</label>
            <p class="small gray4">
              {{ $t("interval-description") }}
            </p>
            <div class="input-group">
              <input
                type="number"
                step="any"
                name="interval"
                class="form-control"
                v-model="interval"
                required
              />
              <div class="input-group-append">
                <span class="input-group-text">{{ $t("minutes") }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="
              profile.role !== 'staff' &&
                (singledevice.data.type === 'mote' ||
                  singledevice.data.type === 'gps-vt')
            "
            class="card"
          >
            <div class="p-2 card-body">
              <div class="row">
                <div class="col-8" style="display: flex; align-items: center;">
                  {{ $t("make-device-private-public") }}
                </div>
                <div
                  class="mb-2 col-4 pl-0 pt-2 d-flex"
                  style="justify-content: flex-end"
                >
                  <span
                    v-if="status === 'private'"
                    @click="changemotestatus('public')"
                    style="display: flex; align-items: center; cursor: pointer; width: 5rem; justify-content: flex-end; background: green; border-radius: 1rem"
                  >
                    <span
                      class="border border-grey shadow-inner shadow"
                      style="width: 3rem; height: 2rem; background: white; border-radius: 1rem; display: flex; justify-content: center; align-items: center;"
                      >{{ $t("private") }}
                    </span>
                  </span>
                  <span
                    v-else
                    @click="changemotestatus('private')"
                    class="border border-grey"
                    style="display: flex; align-items: center; cursor: pointer; width: 5rem; justify-content: flex-start; background: gray; border-radius: 1rem"
                  >
                    <span
                      class="border border-grey shadow-innershadow"
                      style="width: 3rem; height: 2rem; background: white; border-radius: 1rem; display: flex; justify-content: center; align-items: center;"
                      >{{ $t("public") }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row m-t-20">
            <div class="form-group col-md-5">
              <button type="submit" class="btn btn-primary">
                {{ $t("save") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("gricd-all-rights-reserved") }}
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "DeviceSettings",
  data() {
    return {
      devicename: "",
      mintemp: "",
      maxtemp: "",
      minHumi: "",
      maxHumi: "",
      preset: "",
      tempmssg: "",
      humimssg: "",
      status: "",
      boxstatus: false,
      interval: "",
      deviceDescription: "",
      isLoading: true,
      fullPage: true,
      Errormssg: "",
      mssg: "",
      location: "",
    };
  },
  mounted() {
    //console.log(this.$route.params.device_id)
    this.fetchDeviceDetails({ device_id: this.$route.params.device_id })
      .then(() => {
        //console.log(this.singledevice)
        this.devicename = this.singledevice.data.settings.name;
        this.mintemp = this.singledevice.data.settings.minTemp;
        this.minHumi = this.singledevice.data.settings.minHumidity;
        this.maxtemp = this.singledevice.data.settings.maxTemp;
        this.maxHumi = this.singledevice.data.settings.maxHumidity;
        this.preset = this.singledevice.data.settings.preset;
        this.interval = this.singledevice.data.settings.interval;
        this.status = this.singledevice.data.settings.status;
        this.boxstatus = this.singledevice.data.settings.lock;
        this.deviceDescription = this.singledevice.data.deviceDescription;
        this.location = this.singledevice.data.settings.location;
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          //console.log(error.response);
          console.error(error.response.data.message);
          this.$router.push("/404");
        }
      });
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["singledevice", "profile"]),
  },
  methods: {
    ...mapActions(["updateDevice", "fetchDeviceDetails"]),
    changemotestatus(params) {
      this.status = params;
    },
    changeboxstatus() {
      this.boxstatus = !this.boxstatus;
    },
    onSave() {
      this.tempmssg = "";
      this.humimssg = "";
      if (Number(this.mintemp) > Number(this.maxtemp)) {
        this.tempmssg =
          "Minimum temperature cannot be greater than maximum temperature";
      } else if (Number(this.minHumi) > Number(this.maxHumi)) {
        this.humimssg =
          "Minimum humidity cannot be greater than maximum humidity";
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        let deviceupdate;
        if (this.singledevice.data.type === "mote") {
          deviceupdate = {
            name: this.devicename,
            minTemp: Number(this.mintemp),
            maxTemp: Number(this.maxtemp),
            minHumidity: Number(this.minHumi),
            maxHumidity: Number(this.maxHumi),
            interval: parseFloat(this.interval),
            deviceDescription: this.deviceDescription,
            status: this.status,
            location: this.location,
          };
        } else {
          deviceupdate = {
            name: this.devicename,
            minTemp: Number(this.mintemp),
            maxTemp: Number(this.maxtemp),
            minHumidity: Number(this.minHumi),
            maxHumidity: Number(this.maxHumi),
            preset: Number(this.preset),
            deviceDescription: this.deviceDescription,
            interval: parseFloat(this.interval),
            status: this.status,
            lock: this.boxstatus,
            location: this.location,
          };
        }
        this.updateDevice({
          device_id: this.singledevice.data.deviceTag,
          deviceupdate,
        })
          .then((res) => {
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            //console.log(res.data.message);
            setTimeout(() => {
              this.isLoading = true;
            }, 1000);
            setTimeout(() => {
              this.mssg = "";
              this.$router.push("/devices");
            }, 4000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

<i18n>
  {
  "en": {
    "address-device-location": "Address (Device Location)",
    "interval": "Interval",
    "interval-description": "This is the rate at which you want your device to send in data",
    "minutes": "Minute(s)",
    "make-device-private-public": "Make Device Private/Public",
    "private": "Private",
    "public": "Public",
    "save": "Save",
    "gricd-all-rights-reserved": "Gricd. All Rights Reserved"
  },
  "fr": {
    "address-device-location": "Adresse (emplacement de l'appareil)",
    "interval": "Intervalle",
    "interval-description": "Ceci est la fréquence à laquelle vous souhaitez que votre appareil envoie des données",
    "minutes": "Minute(s)",
    "make-device-private-public": "Rendre l'appareil privé/public",
    "private": "Privé",
    "public": "Public",
    "save": "Enregistrer",
    "gricd-all-rights-reserved": "Gricd. Tous droits réservés"
  },
  "sw": {
    "address-device-location": "Anwani (Mahali pa Kifaa)",
    "interval": "Kipindi",
    "interval-description": "Hii ndio kiwango ambacho unataka kifaa chako kitume data",
    "minutes": "Dakika(s)",
    "make-device-private-public": "Fanya Kifaa kuwa Binafsi/Hadharani",
    "private": "Binafsi",
    "public": "Hadharani",
    "save": "Hifadhi",
    "gricd-all-rights-reserved": "Gricd. Haki Zote Zimehifadhiwa"
  }
}
</i18n>
